const FormResources = {

    form_data:  {
        floor_id:       '',
        description:    '',
        abbreviation:   '',
        vacant_bed_adjustment_id: '',
        unit:           1,
        patient:        false,
        housekeeper:    false,
        tasks:          {},
        policing:       {},
    },
    
    form_format:[
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Room Type Name:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'What appears in the Room Description:',
            model_name: 'abbreviation',
            ref:        'abbreviation_input',
            ref_alt:    'abbreviation_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Floor type:',
            model_name: 'floor_id',
            ref:        'floor_id_input',
            ref_alt:    'floor_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  6,
            disabled:   false,
            step:       '',
            name:       'Unit:',
            model_name: 'unit',
            ref:        'unit_input',
            ref_alt:    'unit_input_alt',
            required:   true,
        },
        {
            // css_class:  'col-md-6 justify-content-md-end',
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Patient:',
            model_name: 'patient',
            ref:        'patient_input',
            ref_alt:    'patient_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Group 2:',
            model_name: 'housekeeper',
            ref:        'housekeeper_input',
            ref_alt:    'housekeeper_input_alt',
            required:   false,
        },

    ]


}

export default FormResources